import React from 'react';
import { SEO } from '../components/seo/SEO';
import { CheckCircle2, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getBreadcrumbSchema } from '../lib/jsonLd';

export function NewsletterSuccessPage() {
  const breadcrumbSchema = getBreadcrumbSchema([
    { name: 'Strona główna', url: 'https://znajdki.pl/' },
    { name: 'Zapis do newslettera', url: 'https://znajdki.pl/podziekowanie' },
  ]);

  return (
    <div className="bg-accessible-gray-50 dark:bg-accessible-gray-900 high-contrast:bg-black py-16">
      <SEO
        title="Dziękujemy za zapis do newslettera"
        description="Dziękujemy za zapisanie się do newslettera Fundacji Znajdki. Sprawdź swoją skrzynkę e-mail, aby potwierdzić subskrypcję."
        url="/podziekowanie"
        image="/images/animals/fundacja-znajdki-zwierzeta-001.webp"
        jsonLd={breadcrumbSchema}
      />

      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-10">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center">
            <CheckCircle2 className="w-10 h-10 text-green-600 dark:text-green-400" aria-hidden="true" />
          </div>
          <h1 className="heading-1 mb-4">
            Dziękujemy za zapisanie się!
          </h1>
          <p className="body-large text-accessible-gray-700 dark:text-white/90 max-w-2xl mx-auto">
            Na Twój adres e-mail wysłaliśmy wiadomość z prośbą o potwierdzenie subskrypcji. 
            Sprawdź swoją skrzynkę odbiorczą (oraz folder SPAM lub Oferty), aby dokończyć zapis.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <section className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
                <Mail className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
              </div>
              <h2 className="heading-3 mb-0">
                Co dalej?
              </h2>
            </div>
            <ul className="space-y-3 body-medium">
              <li className="flex items-start gap-2">
                <span className="text-accessible-red-600 mt-1">1.</span>
                <p className="no-margin">
                  Otwórz wiadomość od Fundacji Znajdki i kliknij w przycisk potwierdzający zapis do newslettera.
                </p>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-accessible-red-600 mt-1">2.</span>
                <p className="no-margin">
                  Jeśli nie widzisz wiadomości, sprawdź foldery <strong>SPAM</strong>, <strong>Oferty</strong> lub <strong>Inne</strong>.
                </p>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-accessible-red-600 mt-1">3.</span>
                <p className="no-margin">
                  Dodaj nasz adres do zaufanych nadawców, aby mieć pewność, że kolejne wiadomości trafią do Twojej skrzynki.
                </p>
              </li>
            </ul>
          </section>

          <section className="bg-accessible-red-50 dark:bg-accessible-red-900/20 high-contrast:bg-black p-8 rounded-lg">
            <h2 className="heading-3 mb-4">
              Dziękujemy za Twoje wsparcie
            </h2>
            <p className="body-medium text-accessible-gray-800 dark:text-white/90 mb-4">
              Dzięki Twojej subskrypcji możemy na bieżąco informować Cię o losach naszych podopiecznych, 
              pilnych zbiórkach i sukcesach adopcyjnych.
            </p>
            <p className="body-medium text-accessible-gray-800 dark:text-white/90 mb-6">
              To dla nas bardzo ważne – im więcej osób wie o naszych działaniach, tym więcej zwierząt możemy uratować.
            </p>
            <div className="space-y-3 body-small">
              <p className="no-margin">
                W każdej chwili możesz zrezygnować z newslettera, klikając link rezygnacji w stopce każdej wiadomości.
              </p>
            </div>
          </section>
        </div>

        <div className="text-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-accessible-red-600 text-white px-6 py-3 rounded-lg hover:bg-accessible-red-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accessible-red-600 focus-visible:ring-offset-2 focus-visible:ring-offset-accessible-gray-50 dark:focus-visible:ring-offset-accessible-gray-900 transition-colors"
          >
            Wróć na stronę główną
          </Link>
        </div>
      </div>
    </div>
  );
}


